import 'System/Promises'
import '../Base'
import './Vector'
import '../../Format'

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");

/**
 * @class
 * @extends GIS.Map.Layer.Vector
 * @extends System.Promises
 */
GIS.Map.Layer.GlonassVector = Class(GIS.Map.Layer.Vector, System.Promises, /** @lends GIS.Map.Layer.GlonassVector.prototype */{
    // options
    layerid: null,
    projection: DISPLAY_PROJ,
    format: GIS.Format.GlonassJSON,
    dataGeometryName: 'geog',
    dataPrimaryKeyName: 'id',
    /**
     * Zoom (top value exclusive) to geog name
     * @type {Object<number, string>}
     * @example
     * {
     *   10: geog2,
     *   14: geog1
     * }
     *                    geog2           geog1         geog (default)
     * (Min Zoom) #-------------------|--------------|-----------------> (Max Zoom)
     *            0                   10      ^     14
     *                                        |
     *                                        12 (curr Zoom)
     */
    dataGeometryNameMap: undefined,
    /** @type {Data.ServerSource} */
    ds: null,
    dsMethod: "findForMap",
    dsLimit: 1024,
    dsMaxRequest: 2,
    // subDomains: ['a', 'd'],
    subDomains: [],
    tileSize: [512, 512],
    colorizer: null,
    labelAttribute: null,

    /** @inheritDoc */
    optionNames()
    {
        return this.ParentCall().concat(['ds', 'layerid', 'dsMethod']);
    },
    /** @inheritDoc */
    prepareOptions(options)
    {
        const map = this.map;

        options = this.Parent(options)
        // Glonass always use 4326 behind the scene
        options.projection = DISPLAY_PROJ;
        options.filter_ = {
            ...options.filter_ || {},
            layerid: options.layerid
        }

        let i = 0
        options.loader = requestOptions => {
            if (this.layerid == null) return []
            // prepare shared request params
            let extent = requestOptions.extent || []
            requestOptions.options = _.cloneDeep(requestOptions.options || {})
            requestOptions.filter = _.cloneDeep(this.filter_ || {})

            if (!_.isEmpty(extent) && !_.some(extent, _.negate(_.isFinite))) {
                extent = map.transformExtentProjection(extent, map.getProjection(), this.projection)
                requestOptions.filter.bbox = extent.slice()
            }

            requestOptions.filter.layerid = this.layerid
            if (this.colorizer) {
                requestOptions.options.colorizer = _.cloneDeep(this.colorizer)
            }
            if (this.labelAttribute) {
                requestOptions.options.labelAttribute = _.pick(this.labelAttribute, ['id', 'kindid', 'type'])
            }
            requestOptions.PHPSESSID = context('sessionId')
            // makes XHR request
            const request = async (url, reqOptions) => {
                const key = "featuresLoad:" + Util.String.hash(url + JSON.stringify(reqOptions))
                this.cancelPromise(key)

                // yield request promise
                let jqXHR = $.ajax({
                    url,
                    method: 'GET',
                    dataType: 'json',
                    data: reqOptions
                })

                let response = await this.addPromise(key, jqXHR, () => jqXHR.abort())
                return response && response.data
            }
            // loads one page
            const load = (page) => {
                let reqOptions = _.cloneDeep(requestOptions)

                // update offset / limit in request
                reqOptions.offset = page * this.dsLimit
                reqOptions.limit = this.dsLimit

                let domain
                if (!_.isEmpty(this.subDomains)) {
                    const domains = _.map(
                        _.range(
                            this.subDomains[0].charCodeAt(0),
                            this.subDomains[1].charCodeAt(0) + 1
                        ),
                        x => String.fromCharCode(x)
                    )
                    domain = domains[Util.Math.modulo(i++, domains.length)]
                }

                let url = location.protocol + '//' + (domain ? domain + '.' : '') + location.host + '/'
                    + _.trim(this.ds.url, '/ ') + '/' + _.trim(this.dsMethod, '/ ')

                return request(url, reqOptions)
            }
            // generator to load all available pages
            const loadAll = function* () {
                let page = 0
                let total = 0
                let items, count
                // load first page and wait for result from external code
                let res = yield load(page)
                count = res.count
                items = res.items

                count = count || 0
                total += items.length

                let label
                if (process.env.NODE_ENV !== 'production') {
                    label = 'load extent ' + extent.join(', ')
                    console.log('%c' + label + ': %cloaded %d, total: %d', 'color: #3B94EF; font-weight: bold',
                        'color: #3B94EF', total, count)
                }
                // load other pages if there is more items
                while (items.length && total < (count || 0)) {
                    let res = yield load(++page)
                    items = res.items

                    total += items.length

                    if (process.env.NODE_ENV !== 'production') {
                        console.log('%c' + label + ': %cloaded %d, total: %d', 'color: #3B94EF; font-weight: bold',
                            'color: #3B94EF', total, count)
                    }
                }

                if (process.env.NODE_ENV !== 'production') {
                    console.log('%cdone ' + label + ': %cloaded %d, total: %d', 'color: #3BB96F; font-weight: bold',
                        'color: #3BB96F', total, count)
                }
            }

            return loadAll.call(this)
        }

        return options;
    },
    /**
     * @inheritDoc
     */
    destroy()
    {
        this.cancelAllPromises()
        this.ds = null;

        return this.ParentCall();
    },
    /**
     * @param {number[]} coordinate
     * @param {Object} [options] Data source options
     * @returns {Promise.<Object>}
     */
    async loadFeatureData(coordinate, options)
    {
        const featureData = await this.layer.loadFeatureData(coordinate, options);
        const data = await this.addPromise("loadFeatureData", this.ds.getDocument({ ..._.omit(options, 'feature'), id: featureData.id }));

        return data.item;
    },
    /**
     * @inheritDoc
     */
    filter (filter)
    {
        this.filter_ = filter
        this.clear().refresh()

        return this
    }
});
